import { useEffect } from "react";
import { Link } from "react-router-dom";

function PageNotFound() {
  useEffect(() => {
    document.title = "404:Page Not Found | AttnQ";
  }, []);

  return (
    <main className="min-h-screen flex flex-col justify-center items-center px-4 text-center">
      <div className="mt-12 w-[50vw] lg:w-[25vw]">
        <img
          src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750781851/error-404_njd9cr.png"
          alt="404"
          className="max-w-xs md:max-w-md w-full mx-auto opacity-80"
        />
      </div>

      <h2 className="text-2xl font-semibold text-gray-800 mt-4">
        Page Not Found
      </h2>

      <Link
        to="/"
        className="inline-block bg-[#dc9209] text-gray-100 hover:text-gray-300 px-6 py-2 mt-4 font-semibold rounded-lg shadow hover:bg-[#dc9209] transition"
      >
        Back to Home
      </Link>
    </main>
  );
}

export default PageNotFound;
